// This file is AUTOGENERATED, do not edit it manually!!!

export const projectFinancials = {
    actual_billing: 'Facturación real',
    actual_cost: 'Costo real',
    ActualBillableExpenses: 'Gastos facturables reales',
    ActualBillableExpensesShort: 'Gastos facturables reales',
    ActualBilledShort: 'Facturado real',
    ActualBillingShort: 'Facturación real',
    ActualBudgetProfitability: 'Rendimiento real del presupuesto',
    ActualCost: 'Costo real',
    ActualCostQtip: 'Costo real = Costo laboral real + Gastos reales',
    ActualExpenses: 'Gastos reales',
    ActualExpensesListTitle: 'Real',
    ActualExpensesShort: 'Gastos reales',
    ActualHours: 'Horas reales',
    ActualLaborBilling: 'Mano de obra facturable real',
    ActualLaborBillingShort: 'Mano de obra facturable real',
    ActualLaborCost: 'Costo laboral real',
    ActualLaborCostShort: 'Costo laboral real',
    add_activities_flat_fees: 'agregar tarifas planas de actividades',
    add_as_actual_expense: 'Agregar como gasto real',
    add_planned_billable_expenses: 'agregar gastos facturables planificados',
    add_received_payment: 'Agregar pago recibido',
    add_scheduled_payment: 'Agregar pago programado',
    AddActivitiesBudgets: 'agregar presupuestos de actividades',
    AddBudgetLabel: 'Agregar presupuesto para este proyecto',
    AddPlannedExpenses: 'agregar gastos planificados',
    Amount: 'Monto',
    approvers_problem_warning: 'Uno de los aprobadores ya no puede aprobar los gastos. Actualiza la lista de aprobadores.',
    ApproveTooltip: 'Transfiere los gastos planificados a reales',
    back_to_metrics: 'Volver a métricas',
    batch_actual_text: 'Agregar como gastos reales',
    batch_approval_text: 'Aprobar gastos',
    batch_billed_text: 'Marcar como facturado',
    batch_operation_failed_description: 'No se pudo completar la operación para este gasto. Esto puede deberse a que fue eliminado o a la falta de permisos para realizar operaciones con él. Consulta con tu administrador de {brandName} para conocer las posibles causas.',
    batch_operations_failed_description: 'No se pudo completar la operación para {0} de {1} gastos. Esto puede deberse a que fueron eliminados o a la falta de permisos para realizar operaciones con ellos. Consulta con tu administrador de {brandName} para conocer las posibles causas.',
    batch_reject_text: 'Rechazar gastos',
    Billable: 'Facturable',
    Billed: 'Facturado',
    BilledPercentQtip: 'Facturado = (Mano de obra facturada + Gastos facturados) / Facturable EAC * 100%',
    BilledVsActualCost: 'Facturado vs Costo real',
    Billing: 'Facturación',
    Billing_Info_Title: 'Información de facturación',
    billing_type_item_readonly: 'La edición no está disponible en la cuadrícula cuando el tipo de facturación es Tarifa estándar. Puedes editarlo en la sección de Finanzas',
    BillingHelp: 'En la sección de Facturación puedes elegir el tipo de facturación adecuado para tu proyecto y establecer una tarifa, como por hora, o una cantidad fija para un proyecto de tarifa plana.',
    BillingSettings: 'Configuración de facturación',
    BillingSettingsTitle: 'Facturación',
    BillingType: 'Tipo de facturación',
    BillingTypeLabel: 'Calcular por ',
    BillingUtilization: 'Utilización de facturación anticipada',
    BudgetedCost: 'Presupuesto total del proyecto',
    BudgetHelp: 'En esta sección puedes ver el presupuesto total del proyecto como la suma del de todas sus actividades, y establecer un presupuesto a nivel de proyecto.',
    CancelTooltip: 'Cancelar',
    chart_actual_billing: 'Facturación real',
    chart_actual_cost: 'Costo real',
    chart_billable_expenses: 'Gastos facturables',
    chart_billed: 'Facturado',
    chart_billed_expenses: 'Gastos facturados',
    chart_eac_billing: 'Facturable EAC',
    chart_expenses: 'Gastos',
    chart_non_billable_expenses: 'Gastos no facturables',
    chart_payments: 'Pagos recibidos',
    chart_scheduled_payments: 'Pagos programados',
    ContingencyPadding: 'Contingencia',
    Cost: 'Costo total',
    CPI: 'CPI',
    CurrencyLabel: 'Moneda',
    CustomerHourlyRateLabel: 'Tarifa por hora del cliente',
    Date: 'Fecha',
    delete_the_expense_title: 'Eliminar el gasto',
    delete_the_payment_title: 'Eliminar el pago',
    DeletePaymentConfirmation: '¿Estás seguro de que deseas eliminar este registro?',
    DeleteTooltip: 'Eliminar',
    Description: 'Descripción',
    DetailedReportTitleTemplate: 'Informe detallado para {0}',
    EAC: 'Estimación al completar',
    eac_billing: 'Facturable estimado al completar (EAC)',
    eac_cost: 'Costo estimado al completar (EAC)',
    EACBilling: 'Facturable EAC',
    EACBillingLong: 'Facturable estimado al completar (EAC)',
    EACBillingQtip: 'Facturable estimado al completar (EAC) = Facturable real + Facturable ETC',
    EACBillingQtipInfo: 'Monto total estimado facturable, incluyendo mano de obra facturable y gastos facturables (Real + Estimado al completar (ETC))',
    EACCost: 'Costo estimado al completar (EAC)',
    EACCost_short: 'Costo EAC',
    EACCostQtip: 'Costo estimado al completar (EAC) = Costo real + Costo ETC',
    EnteredBy: 'Ingresado por',
    EstimatedBudgetProfitability: 'Rentabilidad presupuestada estimada',
    EstimatedCostVariance: 'Variación de costo estimada',
    EstimatedExpenses: 'Gastos estimados',
    EstimatedHours: 'Horas estimadas',
    EstimatedProfit: 'Ganancia esperada',
    EstimatedProfitPercentQtip: 'Ganancia esperada (%) = (Facturable EAC - Costo EAC) / Facturable EAC * 100%',
    EstimatedProfitQtip: 'Ganancia esperada = Facturable EAC - Costo EAC',
    etc_billing: 'Facturable estimado a completar (ETC)',
    etc_cost: 'Costo estimado a completar (ETC)',
    ETCBillableExpenses: 'Gastos facturables ETC',
    ETCBillableExpensesShort: 'Gastos facturables ETC',
    ETCBilling: 'Facturable ETC',
    ETCBillingShort: 'Facturable ETC',
    ETCCost: 'Costo ETC',
    ETCCostShort: 'Costo ETC',
    ETCCosttQtip: 'Costo estimado a completar (ETC) = Costo laboral ETC + Gastos ETC',
    ETCExpenses: 'Gastos ETC',
    ETCExpensesShort: 'Gastos ETC',
    ETCLaborBilling: 'Mano de obra facturable ETC',
    ETCLaborBillingShort: 'Mano de obra facturable ETC',
    ETCLaborCost: 'Costo de mano de obra ETC',
    ETCLaborCostShort: 'Costo de mano de obra ETC',
    ExpectedRevenue: 'Ingresos esperados',
    expenses: '1#{0} gasto#{0} gastos',
    expenses_approval_info: 'Habilita la aprobación de gastos para todo el proyecto y todas sus actividades.',
    expenses_approval_label: 'Aprobación de gastos',
    expenses_approval_remove_all_approvers_title: 'Elimina todos los aprobadores, lo que deshabilita el proceso de aprobación de gastos después de guardar.',
    expenses_approved_successfully_plural: '1#El gasto ha sido aprobado#{0} gastos han sido aprobados',
    expenses_rejected_successfully_plural: '1#El gasto ha sido rechazado#{0} gastos han sido rechazados',
    expenses_updated_successfully_plural: '1#El gasto ha sido actualizado correctamente.#{0} gastos han sido actualizados correctamente.',
    FeeAmount: 'Importe de la tarifa',
    FlatFee: 'Tarifa fija',
    GeneralInfo: 'Información general',
    HourlyRate: 'Tarifa por hora',
    InternalBudget: 'Presupuesto',
    InternalEstimatedCost: 'Costo estimado',
    LaborBilling: 'Mano de obra facturable',
    LaborCost: 'Costo de mano de obra',
    legend_actual: 'Real',
    legend_estimated_at_completion: 'Estimado al completar',
    log_actual_expense: 'Registrar gasto real',
    log_expenses: 'Registrar gastos',
    log_payments: 'Registrar pagos',
    log_planned_expense: 'Registrar gasto planificado',
    money_for_date_label: '{0} para {1}?',
    no_targets: 'No hay objetivos para mostrar',
    NoActualExpenses: 'No hay gastos.',
    None: 'Ninguno',
    NoneCurrency: 'Elige moneda',
    NoPayments: 'No hay pagos.',
    NoPlannedExpenses: 'No hay gastos planificados.',
    NotBillable: 'No facturable',
    NotBillableLabel: 'No facturable',
    NotBilled: 'No facturado',
    OpenRateCard: 'Abrir tarjeta de tarifas',
    OutstandingPaymentBalance: 'Saldo de pago pendiente',
    PaymentDescriptionWatermark: 'Descripción...',
    PaymentReceived: 'Pago recibido',
    payments_total: '1#{0} pago#{0} pagos',
    PaymentsOfSchedPayments: 'Pagos de pagos programados',
    PercentageBilled: 'Porcentaje facturado',
    PercentageProjectBilled: 'Porcentaje facturado',
    Percentages: 'Porcentaje',
    PlannedExpenses: 'Gastos planificados',
    PlannedExpensesListTitle: 'Planificado',
    ppFormat: '{0}pp',
    Profit: 'Ganancia',
    ProfitQtip: 'Ganancia = Facturación real - Costo real',
    Project_no_rateCard_for_rateCard_billingType: 'Debe especificar una tarjeta de tarifas si la facturación del proyecto se basa en tarjeta de tarifas.',
    ProjectActivityName: 'Nombre del proyecto / actividad',
    ProjectBilling: 'Facturación del proyecto',
    ProjectBillingIsBasedOn: 'La facturación del proyecto se basa en',
    ProjectBillingUtilization: 'Utilización de facturación',
    ProjectBudget: 'Presupuesto de mano de obra',
    ProjectCost: 'Costo interno del proyecto',
    ProjectCostVariance: 'Variación de costo del proyecto',
    ProjectEarnedValue: 'Valor ganado del proyecto',
    ProjectEarnedValueInfo: 'Representa la salud del proyecto',
    ProjectExpectedRevenue: 'Ingresos esperados del proyecto',
    ProjectFixedCostLabel: 'Tarifa fija del proyecto',
    ProjectHourlyRateLabel: 'Tarifa por hora del proyecto',
    ProjectPayments: 'Pagos del proyecto',
    ProjectPlannedExpenses: 'Gastos planificados del proyecto',
    ProjectPlannedExpensesInfo: 'Gastos planificados para un proyecto específico y gastos planificados agregados de sus actividades',
    ProjectProfit: 'Ganancia del proyecto',
    ProjectProfitability: 'Rentabilidad del proyecto',
    ProjectProfitabilityInfo: 'Representa el porcentaje de valor creado por proyecto',
    ProjectTimeUsage: 'Uso del tiempo del proyecto',
    ProjectTimeUsageInfo: 'Muestra cuánto del tiempo presupuestado hemos utilizado, real como porcentaje de las horas estimadas',
    ProjectWorkInProgress: 'Trabajo en curso del proyecto',
    PymentsVsActualCost: 'Pagos vs costo real',
    RateCardLabel: 'Tarjeta de tarifas',
    Receipt: 'Recibo',
    Received: 'Recibido',
    ReceivedPaymentsListTitle: 'Recibidos',
    RemainingInternalBudget: 'Presupuesto restante',
    RemainingInternalBudgetQtip: 'Presupuesto restante = Presupuesto - Costo real',
    RemainingInternalBudgetQtipForProject: 'Presupuesto restante = Presupuesto total - Costo real',
    ResourceHourlyRateLabel: 'Tarifa por hora del recurso',
    Revenue: 'Ingresos',
    revert_approval_text: 'Editar este gasto restablecerá su estatus a Esperando aprobación y reiniciará el proceso de aprobación desde el principio. Cualquier aprobación o rechazo anterior se perderá. ¿Desea continuar?',
    revert_approval_title: '¿Revertir gasto para reaprobación?',
    Scheduled: 'Programado',
    ScheduledPaymentsListTitle: 'Programados',
    set_targets: 'Establecer objetivos usando el',
    Settings: 'Configuraciones',
    ShowAll: 'MOSTRAR TODO',
    ShowBreakdown: 'Mostrar desglose',
    ShowFull: 'MOSTRAR COMPLETO',
    SPI: 'SPI',
    tab_Actual: 'Gastos reales',
    tab_expenses: 'Gastos',
    tab_overview: 'Resumen',
    tab_payments: 'Pagos',
    tab_Planned: 'Gastos planificados',
    tab_Received: 'Pagos recibidos',
    tab_Scheduled: 'Pagos programados',
    tab_targets: 'Objetivos',
    TargetBudget: 'Presupuesto total',
    TargetLaborRevenue: 'Ingresos objetivo de mano de obra',
    TargetProfit: 'Ganancia objetivo',
    TargetRevenue: 'Ingresos objetivo',
    Targets: 'Objetivos',
    targets_tab: 'Pestaña de objetivos',
    TargetsEACBilling: 'Facturación EAC',
    TaskRateLabel: 'Tarifa de actividad',
    TimeAndMaterial: 'Tiempo y materiales',
    TimeUsage: 'Uso del tiempo',
    TitleText: 'Finanzas',
    total_billable: 'Total facturable',
    TotalBilled: 'Total facturado',
    TotalProjectBudget: 'Presupuesto total del proyecto',
    TotalProjectPayments: 'Pagos totales del proyecto',
    TotalProjectPaymentsInfo: 'Resumen de todos los pagos realizados por todos los clientes',
    TotalTargetRevenue: 'Ingresos objetivo totales',
    TrackProfitAs: 'Rastrear ganancias como',
    Validation_DateMandatory: 'La fecha es un campo obligatorio.',
    Validation_InvalidAmount: 'El monto debe ser un número positivo.',
    Validation_InvalidDate: 'La fecha debe estar en el formato \'{0}\'.',
    Validation_Range: 'El valor no está dentro del rango esperado.',
    Variance: 'Diferencia',
    warning_currency: 'La moneda se toma de la tarjeta de tarifas seleccionada',
    WorkInProgress: 'Trabajo en curso',
};
